import script from "./AskLohnastus.vue?vue&type=script&setup=true&lang=js"
export * from "./AskLohnastus.vue?vue&type=script&setup=true&lang=js"

import "./AskLohnastus.vue?vue&type=style&index=0&id=044187a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-044187a6"]])

export default __exports__